export enum PaymentMethod {
	CreditCard = "card",
	PayPal = "paypal"
}
